import React, { Component } from "react";
import ReactDOM from "react-dom";

class Card extends Component {
  state = {};

  render() {
    return (
      <div className="container">
        <div className="container">
          <div className="card m-4 shadow">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 text-center">
                  <h3 className="text-center">{this.props.country}</h3>
                  {this.getInformation()}
                </div>
                <div className="col-md-6 my-auto">
                  <div class="container">
                    <center>
                      <img src={this.props.flag} width="300" heigth="200" />
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getInformation() {
    if (this.props.population === "") {
      return <div />;
    } else {
      return (
        <div>
          <h5>Population:</h5> {this.props.population.toLocaleString()}
          <h5>Capital:</h5> {this.props.capital}
          {this.getLanguageList()}
        </div>
      );
    }
  }

  getLanguageList() {
    let languageList = [];
    for (let i = 0; i < this.props.languages.length; i++) {
      languageList.push(<li key={i}>{this.props.languages[i].name}</li>);
    }

    return (
      <div>
        <h5>Languages:</h5>
        <ul class="list-unstyled">{languageList}</ul>
      </div>
    );
  }
}

export default Card;
